import React, {useContext, useEffect, useState} from "react";
import {OrganizationTagServiceContext} from "../../Contexts";
import {FilterItem, FilterItemProps, SelectEditor} from "../tablefilter/TableFilter";
import {SearchFilter} from "../tablefilter/SearchFilter";

const TAG_SELECT_MIN_WIDTH = 82;
const TAG_SELECT_MAX_WIDTH = 300;
const TAG_SELECT_CHARACTER_WIDTH = 7;
const TAG_SELECT_ITEM_WIDTH = 34;
const TAG_SELECT_BASE_WIDTH = 28;

interface TagsItemProps extends FilterItemProps {
    tags?: string[];
}

function TagsItem(props: TagsItemProps) {
    return (
        <SelectEditor
            width={tagSelectWidth(props.value)}
            multiple={true}
            showSearch={true}
            options={props.tags?.map(tag => ({
                value: tag,
                label: <span style={{display: "inline-block"}} className="selection-item-text">{tag}</span>
            }))}
            value={props.value}
            onChange={value => props.onChange(value)}
        />
    );
}

function tagSelectWidth(value?: string | string[]) {
    const selectedTags = Array.isArray(value) ? value : value ? [value] : [];

    if (selectedTags.length === 0) {
        return TAG_SELECT_MIN_WIDTH;
    }

    const contentWidth = selectedTags.reduce(
        (sum, tag) => sum + tag.length * TAG_SELECT_CHARACTER_WIDTH + TAG_SELECT_ITEM_WIDTH,
        TAG_SELECT_BASE_WIDTH
    );

    return Math.min(Math.max(contentWidth, TAG_SELECT_MIN_WIDTH), TAG_SELECT_MAX_WIDTH);
}

interface OrganizationFilterProps {
    className?: string;
    values?: any;
    persistentStateIdent?: string;
    onChange: (values: any) => void;
    immediateMode?: boolean;
}

function OrganizationFilter(props: OrganizationFilterProps) {
    const organizationTagService = useContext(OrganizationTagServiceContext);
    const [tags, setTags] = useState<string[]>();

    useEffect(() => {
        organizationTagService.getList()
            .then(setTags);
    }, [organizationTagService]);

    const items: FilterItem[] = [
        {
            name: "tags",
            key: "tags",
            label: "Tag",
            render: itemProps => <TagsItem {...itemProps} tags={tags}/>
        }
    ];

    return (
        <SearchFilter
            items={items}
            className={props.className}
            values={props.values}
            defaultValues={{tags: []}}
            persistentStateIdent={props.persistentStateIdent}
            defaultActiveFilterNames={["tags"]}
            immediateMode={props.immediateMode}
            onChange={props.onChange}
        />
    );
}

export default OrganizationFilter;
